var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"rtp__header-c"}},[_c('CardLayoutLogo'),_c('CardLayoutTitle',[_vm._v(" Crie um novo PIN ")]),_c('PinStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }